"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;

var _core = require("@material-ui/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _core.makeStyles)(function () {
  return {
    loadingWrapper: function loadingWrapper(props) {
      return props.overlay ? {
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        zIndex: 10000,
        top: 0,
        left: 0,
        backgroundColor: props.overlayBackground || '#fff'
      } : {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      };
    },
    loadingImage: {
      animation: '$spin 1.5s linear infinite',
      WebkitAnimation: '$spin 1.5s linear infinite',
      MozAnimation: '$spin 1.5s linear infinite'
    },
    '@keyframes spin': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@-webkit-keyframes spin': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@-moz-keyframes spin': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    }
  };
});

var Loading = function Loading(props) {
  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.loadingWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.loadingImage
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "87",
    height: "82",
    viewBox: "0 0 87 82"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#C5DA00",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.486 49.807c8.755 0 15.341 13.095 15.341 21.773 0 8.678-6.663 10.382-15.341 10.382-8.6 0-15.342-1.704-15.342-10.382 0-8.6 6.586-21.773 15.342-21.773zm0 3.022c-7.206 0-12.552 11.39-12.552 18.208 0 6.896 5.656 7.826 12.552 7.826 6.973 0 12.552-.93 12.552-7.826 0-6.818-5.346-18.208-12.552-18.208z",
    opacity: ".3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.961 40.768c0 8.755-13.094 15.341-21.772 15.341C2.51 56.11.806 49.446.806 40.768c0-8.6 1.705-15.342 10.383-15.342 8.6 0 21.772 6.586 21.772 15.342zm-3.022 0c0-7.206-11.39-12.552-18.208-12.552-6.896 0-7.825 5.656-7.825 12.552 0 6.973.93 12.552 7.825 12.552 6.819 0 18.208-5.346 18.208-12.552z",
    opacity: ".1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.01 40.768c0 8.755 13.095 15.341 21.773 15.341 8.678 0 10.382-6.663 10.382-15.341 0-8.6-1.704-15.342-10.382-15.342-8.6 0-21.773 6.586-21.773 15.342zm3.022 0c0-7.206 11.39-12.552 18.208-12.552 6.896 0 7.826 5.656 7.826 12.552 0 6.973-.93 12.552-7.826 12.552-6.818 0-18.208-5.346-18.208-12.552z",
    opacity: ".6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.486 32.374c8.755 0 15.341-13.094 15.341-21.772 0-8.678-6.663-10.383-15.341-10.383-8.6 0-15.342 1.705-15.342 10.383 0 8.6 6.586 21.772 15.342 21.772zm0-3.022c-7.206 0-12.552-11.39-12.552-18.208 0-6.896 5.656-7.826 12.552-7.826 6.973 0 12.552.93 12.552 7.826 0 6.818-5.346 18.208-12.552 18.208z"
  })))));
};

exports.Loading = Loading;